import React from "react";
import ReactPaginate from "react-paginate";
import { paginationList } from "content/static";

const HeaderComponent = ({ rowData, pageLimit, setPageLimit, handlePageClick, pageCount, totalRows }) => {
    if (!rowData||rowData.length === 0) {
        return null
    }
    return <div className="row">

        <div className="col">
            <div className="pt-3 form-inline pull-left">
                <label className="m-0 pr-2 text-default">
                    Page View:{" "}
                </label>
                <select
                    className="form-control"
                    value={pageLimit}
                    onChange={(e) => setPageLimit(e.target.value)}
                >
                    {paginationList.map((state) => (
                        <option value={state.value}>{state.label}</option>
                    ))}
                </select>
            </div>
        </div>
        <div className="col">
            <div className="pagination pt-3">
                <ReactPaginate
                    breakLabel="..."
                    nextLabel=">>"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    pageCount={pageCount}
                    previousLabel="<<"
                    renderOnZeroPageCount={null}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    containerClassName={"pagination"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    activeClassName={"active"}
                />
            </div>
        </div>
        <div className="col">
            <div className="p-0 m-0 pt-3 pull-right">
                <h5 className="text-center">
                    <strong className="text-default">Total: </strong>
                    <strong className="text-success">
                        {totalRows}
                    </strong>
                </h5>
            </div>
        </div>
    </div>
}

export default HeaderComponent